module.exports = __webpack_public_path__ + "img/logo.ed255d20.png";